/**
 * attribute_code → i18n Feld-Label (user-sichtbar).
 * Kein React-Hook verfügbar (labels.ts wird auch außerhalb von Komponenten
 * genutzt) — daher die i18next-Singleton-Instanz direkt (Muster `lib/api/generation.ts:7`).
 * Keys: `channelContent.card.attribute.*` (T3, deckt title/description/
 * short_description/bullets/seo_title/seo_description ab).
 */
import i18n from '@/i18n'

export function attrLabel(code: string): string {
  return i18n.t(`channelContent.card.attribute.${code}`, { defaultValue: code })
}
